<template>
  <div class="level">
    <LevelRow
      @toggle="toggleExercise"
      :hasAccess="hasAccess"
      :contentType="contentType"
      :contentId="content.uuid"
      :status="contentStatus"
      :parentStatus="courseStatus"
      :title="title"
      :plansLink="plansLink"
      :isWatching="isWatching"
      :details="exerciseDetails"
      :progress="progress"
      @click.native="toggleExercise"
    >
    </LevelRow>
    <div class="level__content" v-if="isWatching">
      <div class="content__exercises">
        <MediaDelegate
          v-bind="{
            parentType: 'course',
            content: { type: contentType, media: content.exercises },
            userCompletionStatus: contentStatus,
            hasAccess: hasAccess,
          }"
        />
      </div>
      <div v-if="isLoading" class="content__loader-wrapper">
        <ActionLoader loaderClass="content__loader" name="ball-clip-rotate" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CONSTANTS from '@/constants'
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import LevelRow from '@/components/content/level/LevelRow.vue'

export default {
  name: 'ExcercisesLevel',
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    LevelRow,
    MediaDelegate,
    ActionLoader,
  },
  props: {
    courseStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: false,
    },
    contentStatus: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      currentExercisesId: state => state.content.currentExercisesId,
    }),
    contentType() {
      return CONSTANTS.CONTENT_TYPES.EXERCISE
    },
    exerciseDetails() {
      return this.content.exercises.length > 1
        ? [`${this.content.exercises.length} exercises`]
        : [`${this.content.exercises.length} exercise`]
    },
    progress() {
      const count = this.content.exercises.reduce(
        (acc, cur) =>
          cur &&
          cur.user_status &&
          cur.user_status === CONSTANTS.CONTENT_USER_STATUS.FINISHED
            ? ++acc
            : acc,
        0
      )
      return this.content.exercises.length > 0
        ? (100 * count) / this.content.exercises.length
        : 0
    },
    isWatching() {
      return this.content.uuid === this.currentExercisesId
    },
  },
  methods: {
    async toggleExercise() {
      if (this.hasAccess && !this.isLoading) {
        this.isLoading = true
        const { currentExercisesId, content } = this
        if (currentExercisesId === content.uuid) {
          this.$store.dispatch('content/setCurrentExercisesId', '')
        } else {
          this.$store.dispatch('content/setCurrentExercisesId', content.uuid)
        }
        this.$emit('toggle-content', CONSTANTS.CONTENT_TYPES.EXERCISE_GROUP)
        this.isLoading = false
      }
    },
    hasCompleted() {
      if (!this.hasAccess) return '#3A3A3A'
      return this.exerciseStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED
        ? '#00DEA0'
        : '#808080'
    },
  },
}
</script>
